(() => {
	window.dealOptionsChange = function() {
	    ['#select-model', '#select-size', '#select-colour'].forEach((selector) => {
	        document.querySelector(selector).addEventListener('change', event => refreshPage(event.target.value));
	    });
    }

    function refreshPage(slug) {
        let newLocationHref = '/' + slug.toLowerCase() + '/deals?' + window.location.search.substr(1);
        window.location.href = newLocationHref;
    }
    
    dealOptionsChange();

})();
